import React, { createContext, useContext, useEffect } from "react";

import useHiddenFields from "~/context/MarketingContext/hooks/useHiddenFields";
import useUtmParams from "~/context/MarketingContext/hooks/useUtmParams";
import useUserPardotData from "~/context/MarketingContext/hooks/useUserPardotData";

const MarketingContext = createContext();

export const MarketingProvider = ({ children }) => {
    const { hiddenFieldValues, setHiddenFields } = useHiddenFields();

    const utmActions = useUtmParams();

    const pardotUserData = useUserPardotData();

    const { save } = utmActions;

    useEffect(() => {
        save();
    }, [save]);

    return (
        <MarketingContext.Provider
            value={{
                hiddenFieldValues,
                setHiddenFields,
                ...pardotUserData,
            }}
        >
            {children}
        </MarketingContext.Provider>
    );
};

export const useMarketingContext = () => {
    const context = useContext(MarketingContext);

    if (context === undefined) {
        throw new Error(
            "useMarketingContext must be used within a MarketingProvider",
        );
    }

    return context;
};
